export const PURCHASE_ORIGINS = {
  STORES: 'Stores',
  BOOKINGS: 'Bookings',
  WIX_EVENTS: 'Wix Events',
};
